import React from 'react';
import { MapPin, Trash2, Move } from 'lucide-react';
import BottomSheet from './BottomSheet';
import PrimaryButton from './PrimaryButton';

export default function PlantBottomSheet({
  open,
  onClose,
  marker,
  onReposition,
  onRemoveFromMap,
}) {
  if (!marker) return null;
  const name = marker.common_name || marker.nickname || 'Plant';

  return (
    <BottomSheet open={open} onClose={onClose} title={name}>
      <div className="space-y-3">
        {marker.plant_type ? (
          <div className="text-sm text-garden-muted capitalize">{marker.plant_type}</div>
        ) : null}

        {marker.label ? (
          <div className="flex items-start gap-2 text-sm text-garden-ink">
            <MapPin size={16} className="mt-0.5 text-garden-muted" />
            <span>{marker.label}</span>
          </div>
        ) : null}

        <div className="pt-2 flex flex-wrap gap-2">
          <PrimaryButton variant="secondary" onClick={() => onReposition?.(marker)}>
            <Move size={16} /> Reposition
          </PrimaryButton>
          <PrimaryButton variant="secondary" onClick={() => onRemoveFromMap?.(marker)}>
            <Trash2 size={16} /> Remove from map
          </PrimaryButton>
        </div>
        <p className="text-xs text-garden-muted pt-1">
          Tap a marker to open the plant. Press and hold (mobile) to drag it to a
          new spot, or right-click (desktop) to reopen this menu.
        </p>
      </div>
    </BottomSheet>
  );
}
